import { Layout, Menu, Breadcrumb, Button, Divider, Select, Drawer, Tooltip } from 'antd';

import './layout.css'
import { LocalStorageService } from "../../../service/local-storage-service";
import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    GroupOutlined,
    KeyOutlined,
    MenuOutlined,
    UserOutlined,
    LaptopOutlined,
    CalendarOutlined,
    UnorderedListOutlined,
    CloseOutlined,
    HistoryOutlined,
    FileTextOutlined,
    ExportOutlined
} from "@ant-design/icons";
import Flex from "../../Flex";
import Logo from "./Logo";
import { BiFirstAid } from "react-icons/bi";
import { Pages } from "../../../../AppRouter";
import { AiFillSetting } from "react-icons/ai";
import ProfileDropdown from "./ProfileDropdown";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useState } from "react";

import { ImInsertTemplate } from 'react-icons/im'
import { RiDashboardLine } from 'react-icons/ri'
import { HiOutlineDocumentReport } from 'react-icons/hi'
import { FaRegHospital } from 'react-icons/fa'
import { PERMISSIONS, useUser } from "../../../context/UserContext";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import NotificationMenu from "../../../../app/notification-menu";
import { useIsSmallScreen } from "../../../utils/useMediaQuery";

const { Header } = Layout;

const { SubMenu } = Menu;
export default function MainLayout({ children }) {
    const isSmallScreen = useIsSmallScreen(992);
    const { t } = useTranslation();
    const history = useHistory();
    const key = window.location.pathname;
    const { hasPermission, showDashboard, user } = useUser()
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const hasSystemPermission = hasPermission(PERMISSIONS.HOSPITAL_MANAGER)
        || hasPermission(PERMISSIONS.REPORT_TEMPLATE_MANAGER)
        || hasPermission(PERMISSIONS.REQUEST_TYPE_MANAGER)
        || hasPermission(PERMISSIONS.USER_MANAGER)
        || hasPermission(PERMISSIONS.DEVICE_LIST)
        || hasPermission(PERMISSIONS.WORKLIST_LIST)
        || hasPermission(PERMISSIONS.LOG_MANAGEMENT)
        || hasPermission(PERMISSIONS.TELETIP_MANAGER)
        || hasPermission(PERMISSIONS.HL7_MANAGER)
        || hasPermission(PERMISSIONS.AUTO_EXPORT_MANAGE)

    // Merkezi navigasyon.
    // - Sol tık (normal): normal geçiş.
    // - Orta tık / Ctrl (yeni sekmede aç): tarayıcıda yeni sekme.
    const appNavigate = (path, opts = {}) => {
        if (opts.newTab) {
            window.open(path, '_blank')
        } else {
            history.push(path)
        }
    }

    const onClick = (item) => {
        const e = item?.domEvent
        const newTab = !!(e && (e.ctrlKey || e.metaKey))  // Ctrl/Cmd + tık => yeni sekme
        appNavigate(item.key, { newTab })
        setMobileMenuOpen(false)
    }

    // Menüde orta tık => "yeni sekmede aç" (config'e göre uygulama içi / tarayıcı)
    const handleAux = (e) => {
        if (e.button !== 1) return
        const el = e.target.closest && e.target.closest('[data-menu-id]')
        if (!el) return
        const id = el.getAttribute('data-menu-id') || ''
        const slash = id.indexOf('/')
        if (slash === -1) return
        e.preventDefault()
        appNavigate(id.slice(slash), { newTab: true })
    }

    return (
        <Layout>
            {
                isSmallScreen && (
                    <>
                        <Header id={'site-header'} style={{ position: 'fixed', zIndex: 100, width: '100%', height: 64, backgroundColor: '#34495e', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                            <Flex alignItems={'center'} justifyContent={'space-between'} style={{ width: '100%', padding: '0 8px' }}>
                                <Button
                                    type="text"
                                    icon={<MenuOutlined style={{ fontSize: 20, color: '#fff' }} />}
                                    onClick={() => setMobileMenuOpen(true)}
                                    style={{ width: 48, height: 48 }}
                                />
                                <Logo />
                                <Flex alignItems={'center'} gap={4}>
                                    <NotificationMenu />
                                    <ProfileDropdown />
                                </Flex>
                            </Flex>
                        </Header>
                        <Drawer
                            title={<Logo />}
                            placement="left"
                            onClose={() => setMobileMenuOpen(false)}
                            open={mobileMenuOpen}
                            width="280px"
                            styles={{
                                body: { padding: 0 },
                                header: { borderBottom: '1px solid #f0f0f0' }
                            }}
                            closeIcon={<CloseOutlined />}
                        >
                            <Menu
                                onClick={onClick}
                                mode="inline"
                                selectedKeys={[key]}
                                style={{ border: 'none' }}
                            >
                                {showDashboard() && (
                                    <Menu.Item key={Pages.Dashboard.Home} icon={<RiDashboardLine />}>
                                        {t('Dashboard')}
                                    </Menu.Item>
                                )}
                                {hasPermission(PERMISSIONS.STUDY_LIST) && (
                                    <Menu.Item icon={<BiFirstAid />} key={Pages.Study.Study}>
                                        {t('Study')}
                                    </Menu.Item>
                                )}
                                {hasPermission(PERMISSIONS.REPORT_LIST) && (
                                    <Menu.Item icon={<HiOutlineDocumentReport />} key={Pages.Report.DataGrid}>
                                        {t('Reports')}
                                    </Menu.Item>
                                )}
                                {hasPermission(PERMISSIONS.WORKLIST_LIST) && (
                                    <SubMenu key="worklist" icon={<UnorderedListOutlined />} title={t('Worklist')}>
                                        <Menu.Item icon={<UnorderedListOutlined />} key={Pages.WorklistItem.DataGrid}>
                                            {t('Worklist')}
                                        </Menu.Item>
                                        {hasPermission(PERMISSIONS.WORKLIST_CREATE_EDIT) && (
                                            <Menu.Item icon={<CalendarOutlined />} key={Pages.Appointment.Scheduler}>
                                                {t('Appointments')}
                                            </Menu.Item>
                                        )}
                                    </SubMenu>
                                )}
                                {hasSystemPermission && (
                                    <SubMenu key="sub4" icon={<AiFillSetting />} title={t('System')}>
                                        {hasPermission(PERMISSIONS.HOSPITAL_MANAGER) && (
                                            <Menu.Item icon={<FaRegHospital />} key={Pages.Hospital.Hospital}>
                                                {t('Hospital')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.HOSPITAL_GROUP_MANAGER) && (
                                            <Menu.Item icon={<FaRegHospital />} key={Pages.HospitalGroup.HospitalGroupEdit}>
                                                {t('Hospital Groups')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.HL7_MANAGER) && (
                                            <Menu.Item icon={<FaRegHospital />} key={Pages.HL7.DataGrid}>
                                                {t('HL7')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.TELETIP_MANAGER) && (
                                            <Menu.Item icon={<FaRegHospital />} key={Pages.Teletip.DataGrid}>
                                                {t('Teletip')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.DEVICE_LIST) && (
                                            <Menu.Item icon={<LaptopOutlined />} key={Pages.Device.DataGrid}>
                                                {t('Devices')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.REPORT_TEMPLATE_MANAGER) && (
                                            <Menu.Item icon={<ImInsertTemplate />} key={Pages.ReportTemplate.DataGrid}>
                                                {t('Report Templates')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.REQUEST_TYPE_MANAGER) && (
                                            <Menu.Item icon={<GroupOutlined />} key={Pages.RequestType.System}>
                                                {t('Request Types')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.USER_MANAGER) && (
                                            <Menu.Item icon={<KeyOutlined />} key={Pages.Role.Manager}>
                                                {t('Roles')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.USER_MANAGER) && (
                                            <Menu.Item icon={<UserOutlined />} key={Pages.User.DataGrid}>
                                                {t('Users')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.LOG_MANAGEMENT) && (
                                            <Menu.Item icon={<FileTextOutlined />} key={Pages.Log.DataGrid}>
                                                {t('Logs')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.LOG_MANAGEMENT) && (
                                            <Menu.Item icon={<FileTextOutlined />} key={Pages.Log.AppLogs}>
                                                {t('App Logs')}
                                            </Menu.Item>
                                        )}
                                        {hasPermission(PERMISSIONS.AUTO_EXPORT_MANAGE) && (
                                            <Menu.Item icon={<ExportOutlined />} key={Pages.AutoExport.Rules}>
                                                {t('Auto Export Rules')}
                                            </Menu.Item>
                                        )}
                                    </SubMenu>
                                )}
                            </Menu>
                        </Drawer>
                    </>
                )
            }
            {
                !isSmallScreen && (
                    <Header id={'site-header'} style={{ position: 'fixed', zIndex: 100, width: '100%', height: 64, backgroundColor: '#34495e', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                        <Flex alignItems={'center'}>
                            <Logo />
                            <span
                                onAuxClick={handleAux}
                                onMouseDown={(e) => { if (e.button === 1) e.preventDefault() }}
                                style={{ flex: 1, minWidth: 0, display: 'flex' }}
                            >
                            <Menu
                                style={{ marginLeft: 16, flex: 1, backgroundColor: 'transparent', borderBottom: 'none' }}
                                onClick={onClick}
                                theme="dark"
                                mode="horizontal"
                                defaultSelectedKeys={[key]}
                            >

                                {showDashboard() && (<Menu.Item key={Pages.Dashboard.Home} icon={<RiDashboardLine />} title={t('Dashboard')} />)}
                                {hasPermission(PERMISSIONS.STUDY_LIST) && (<Menu.Item icon={<BiFirstAid />} key={Pages.Study.Study}>{t('Study')}</Menu.Item>)}
                                {hasPermission(PERMISSIONS.REPORT_LIST) && (<Menu.Item icon={<HiOutlineDocumentReport />} key={Pages.Report.DataGrid}>{t('Reports')}</Menu.Item>)}
                                {hasPermission(PERMISSIONS.WORKLIST_LIST) && (
                                    <SubMenu key="worklist" icon={<UnorderedListOutlined />} title={t('Worklist')}>
                                        {hasPermission(PERMISSIONS.WORKLIST_LIST) && (<Menu.Item icon={<UnorderedListOutlined />} key={Pages.WorklistItem.DataGrid}>{t('Worklist')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.WORKLIST_CREATE_EDIT) && (<Menu.Item icon={<CalendarOutlined />} key={Pages.Appointment.Scheduler}>{t('Appointments')}</Menu.Item>)}
                                    </SubMenu>
                                )}
                                {hasSystemPermission && (
                                    <SubMenu key="sub4" icon={<AiFillSetting />} title={t('System')}>
                                        {hasPermission(PERMISSIONS.HOSPITAL_MANAGER) && (<Menu.Item icon={<FaRegHospital />} key={Pages.Hospital.Hospital}>{t('Hospital')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.HOSPITAL_GROUP_MANAGER) && (<Menu.Item icon={<FaRegHospital />} key={Pages.HospitalGroup.HospitalGroupEdit}>{t('Hospital Groups')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.HL7_MANAGER) && (<Menu.Item icon={<FaRegHospital />} key={Pages.HL7.DataGrid}>{t('HL7')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.TELETIP_MANAGER) && (<Menu.Item icon={<FaRegHospital />} key={Pages.Teletip.DataGrid}>{t('Teletip')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.DEVICE_LIST) && (<Menu.Item icon={<LaptopOutlined />} key={Pages.Device.DataGrid}>{t('Devices')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.REPORT_TEMPLATE_MANAGER) && (<Menu.Item icon={<ImInsertTemplate />} key={Pages.ReportTemplate.DataGrid}>{t('Report Templates')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.REQUEST_TYPE_MANAGER) && (<Menu.Item icon={<GroupOutlined />} key={Pages.RequestType.System}>{t('Request Types')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.USER_MANAGER) && (<Menu.Item icon={<KeyOutlined />} key={Pages.Role.Manager}>{t('Roles')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.USER_MANAGER) && (<Menu.Item icon={<UserOutlined />} key={Pages.User.DataGrid}>{t('Users')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.LOG_MANAGEMENT) && (<Menu.Item icon={<FileTextOutlined />} key={Pages.Log.DataGrid}>{t('Logs')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.LOG_MANAGEMENT) && (<Menu.Item icon={<FileTextOutlined />} key={Pages.Log.AppLogs}>{t('App Logs')}</Menu.Item>)}
                                        {hasPermission(PERMISSIONS.AUTO_EXPORT_MANAGE) && (<Menu.Item icon={<ExportOutlined />} key={Pages.AutoExport.Rules}>{t('Auto Export Rules')}</Menu.Item>)}
                                    </SubMenu>
                                )}
                            </Menu>
                            </span>
                            <NotificationMenu />
                            <ProfileDropdown />
                        </Flex>
                    </Header>
                )
            }
            <Layout className="site-layout">
                {children}
            </Layout>
        </Layout>
    )
}
